import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lastMessage: null,
  status: 'disconnected', // 'connected' | 'disconnected'
  roundId: null,
};

const aviatorSocketSlice = createSlice({
  name: 'aviatorSocket',
  initialState,
  reducers: {
    connected(state) {
      state.status = 'connected';
    },
    disconnected(state) {
      state.status = 'disconnected';
    },
    messageReceived(state, action) {
      state.lastMessage = action.payload;
      state.roundId = action.payload?.roundId || state.roundId; // update roundId
    },
    errorOccurred(state, action) {
      state.error = action.payload;
    },
  },
});

export const { connected, disconnected, messageReceived, errorOccurred } = aviatorSocketSlice.actions;
export default aviatorSocketSlice.reducer;
